<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.10867 12.0176L3.73153 13.3957C3.42227 13.704 3.42227 14.2064 3.73153 14.5157C4.04079 14.8249 4.54221 14.8249 4.85147 14.5157L6.3507 13.0164C7.75487 13.9732 9.41326 14.5827 11.2028 14.7228V16.4583C11.2028 16.8957 11.558 17.251 11.9954 17.251C12.4328 17.251 12.7871 16.8957 12.7871 16.4583V14.7228C14.5776 14.5827 16.2359 13.9732 17.6391 13.0164L19.1384 14.5157C19.4476 14.8249 19.95 14.8249 20.2593 14.5157C20.5686 14.2064 20.5686 13.704 20.2593 13.3957L18.8811 12.0176C20.1022 10.8656 21.035 9.41143 21.5594 7.77506C21.6925 7.35872 21.4623 6.91234 21.046 6.77823C20.6296 6.64512 20.1832 6.8753 20.0501 7.29165C18.9592 10.6995 15.7635 13.1696 11.9954 13.1696C8.22727 13.1696 5.03162 10.6995 3.94071 7.29165C3.8066 6.8753 3.36023 6.64512 2.94388 6.77823C2.52754 6.91234 2.29833 7.35872 2.43144 7.77506C2.95488 9.41143 3.88766 10.8656 5.10867 12.0176Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'EyeClose'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
